/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function Collection(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.25015 15.5C3.25015 16.1903 3.8098 16.75 4.50015 16.75H15.0002V18.25H4.50015C2.98137 18.25 1.75015 17.0188 1.75015 15.5V4.99999H3.25015V15.5ZM16.3332 1.66698C17.4377 1.66698 18.3332 2.56241 18.3332 3.66698V13C18.333 14.1044 17.4376 15 16.3332 15H7.00015L6.79605 14.9902C5.78745 14.888 5.00032 14.0355 5.00015 13V3.66698C5.00015 2.56241 5.89558 1.66698 7.00015 1.66698H16.3332ZM7.00015 3.16698C6.72401 3.16698 6.50015 3.39084 6.50015 3.66698V13C6.50033 13.276 6.72412 13.5 7.00015 13.5H16.3332C16.6092 13.5 16.833 13.276 16.8332 13V3.66698C16.8332 3.39084 16.6093 3.16698 16.3332 3.16698H7.00015ZM15.8332 11.667H7.50015L9.75015 8.74999L11.0421 10.417L12.9582 7.91698L15.8332 11.667Z"
        fill="#35424F"
      />
    </svg>
  )
}

Collection.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default Collection
